module.exports = __webpack_public_path__ + "static/media/bg.ef420e1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.mp4
// module id = vyDO
// module chunks = 0